module.exports = __webpack_public_path__ + "img/trash_view_contact.fde2fc30.svg";